import featureFlagService, { featureKeys } from 'services/FeatureFlagService';
import ActivityHistoryById from 'services/walkable/query/ActivityHistoryById';
import CoursewareItemResolver from 'services/coursewareItem/CoursewareItemResolver';
import getActivityHistory from './query/getActivityHistory.gql';
import client from '../../ConnectionManager/apolloClient';
import CoursewareItemProvider from '../coursewareItem/CoursewareItemProvider';


class HistoryProvider {
  constructor() {
    this._subscriptions = [];
  }

  async getActivityHistory(activityId) {
    const isPOCRTMEnabled = featureFlagService.is(featureKeys.LEARNSPACE_RTM_SOLUTION_1_POC);
    const { cohortId, deploymentId } = CoursewareItemProvider.getDeploymentContext();
    let data;
    if (isPOCRTMEnabled) {
      data = await this.getHistoryDataFromSocket(cohortId, deploymentId, activityId);
    } else {
      data = await this.getHistoryDataFromGraphql(cohortId, deploymentId, activityId);
    }
    const { pathways = [] } = data.learn.cohort.deployment[0].activity || {};
    // Alternate approach - squish histories to one big list (sorted by time?)
    // return histories.reduce((acc, val) => [...acc, ...val], []).sort((a, b) => a.evaluatedAt > b.evaluatedAt);
    return pathways
      .map((pathway) => pathway.history.edges.map(({ node }) => node));
  }

  async getHistoryDataFromSocket(cohortId, deploymentId, activityId) {
    const query = ActivityHistoryById.getActivityHistoryById(cohortId, deploymentId, activityId);
    const result = await CoursewareItemResolver.sendGraphqlQuery(query);
    return result.data;
  }

  async getHistoryDataFromGraphql(cohortId, deploymentId, activityId) {
    const result = await client.query({
      query: getActivityHistory,
      variables: {
        cohortId,
        deploymentId,
        activityId,
      },
      errorPolicy: 'ignore',
      fetchPolicy: 'network-only',
    });
    return result.data;
  }

  async subscribeToActivityHistory(activityId, callback, coursewareId) {
    const subscription = { coursewareId, callback };
    this._subscriptions[activityId] = this._subscriptions[activityId] || [];
    this._subscriptions[activityId].push(subscription);
    this.getActivityHistory(activityId).then((histories) => {
      subscription.callback(histories || []);
    });
    return this._createUnsubscribe(activityId, subscription.callback);
  }

  cleanPluginSubscriptions(coursewareId) {
    Object.keys(this._subscriptions).forEach((activityId) => {
      this._subscriptions[activityId] = this._subscriptions[activityId].filter((subscription) => subscription.coursewareId !== coursewareId);
    });
  }

  async notifySubscribers(activityId) {
    const isDynamicQueryNonBlockingEnabled = featureFlagService.is(featureKeys.LEARNSPACE_DYNAMIC_CALLS_NON_BLOCKING);

    if (isDynamicQueryNonBlockingEnabled) {
      this.getActivityHistory(activityId).then((histories) => {
        const subscriptions = this._subscriptions[activityId] || [];
        subscriptions.forEach((subscription) => subscription.callback(histories || []));
      });
    } else {
      const histories = await this.getActivityHistory(activityId);
      const subscriptions = this._subscriptions[activityId] || [];
      subscriptions.forEach((subscription) => subscription.callback(histories || []));
    }
  }

  _createUnsubscribe(activityId, callback) {
    return () => {
      this._subscriptions[activityId] = this._subscriptions[activityId].filter((subscription) => subscription.callback !== callback);
    };
  }
}

export default new HistoryProvider();
